import { render, staticRenderFns } from "./dialogTips.vue?vue&type=template&id=3af30071&"
import script from "./dialogTips.vue?vue&type=script&lang=js&"
export * from "./dialogTips.vue?vue&type=script&lang=js&"
import style0 from "./dialogTips.vue?vue&type=style&index=0&id=3af30071&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports